import type { Creative, CreativeContentWriteResponse } from '@/api/types';
import type { CreativePatchInput } from '@/api/manage-types';

type Snapshot = Pick<Creative, 'id' | 'revision' | 'content_hash' | 'spec' | 'destination_url'>;

/** Omitted content stays untouched; supplied content is guarded by what was read. */
export function creativePatch(before: Snapshot, desired: CreativePatchInput): CreativePatchInput {
  const patch = { ...desired, expected_revision: before.revision };
  if (patch.spec === before.spec) delete patch.spec;
  if (patch.destination_url === before.destination_url) delete patch.destination_url;
  if (patch.spec !== undefined || patch.destination_url !== undefined) {
    // Legacy rows without a presented hash are refused by the API with a
    // reload instruction; constructing dirty-state UI must still be safe.
    patch.expected_content_hash = before.content_hash ?? '';
  }
  return patch;
}

/** Only a successfully created draft record can be addressed by this wizard. */
export async function patchCreatedCreative(
  record: { id: string; snapshot: Snapshot },
  desired: CreativePatchInput,
  write: (input: { id: string; patch: CreativePatchInput }) => Promise<CreativeContentWriteResponse>,
): Promise<void> {
  if (record.id !== record.snapshot.id) throw new Error('Creative draft identity changed; reload.');
  const response = await write({ id: record.id, patch: creativePatch(record.snapshot, desired) });
  record.snapshot = response.creative;
}
